import React from 'react';
import Navbar from '../section/navbar/Navbar';
import Footer from '../section/Footer';

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
